module.exports = __webpack_public_path__ + "static/media/zacke~JOMwxltQ.c317709d.svg";